import { createGlobalState } from 'react-use';

const useCopyModal = createGlobalState(false);
const useCreateModal = createGlobalState(false);
const useDeleteModal = createGlobalState(false);
const useMoveModal = createGlobalState(false);
const useRenameModal = createGlobalState(false);
const useImportModal = createGlobalState(false);

export enum TemplateFolderModals {
  All = 'all',
  Copy = 'copy',
  Create = 'create',
  Delete = 'delete',
  Move = 'move',
  Rename = 'rename',
  Import = 'import',
}
/**
 * This hook creates a global state that can be used to track template folder modals and selectively
 * open and close them from any component without having to pass props around
 */
export function useTemplateFolderModals() {
  const [showCopyModal, setShowCopyModal] = useCopyModal();
  const [showCreateModal, setShowCreateModal] = useCreateModal();
  const [showDeleteModal, setShowDeleteModal] = useDeleteModal();
  const [showMoveModal, setShowMoveModal] = useMoveModal();
  const [showRenameModal, setShowRenameModal] = useRenameModal();
  const [showImportModal, setShowImportModal] = useImportModal();

  return {
    [TemplateFolderModals.All]: {
      // any shown (property name kept for consistency)
      isShown:
        showCopyModal || showCreateModal || showDeleteModal || showMoveModal || showRenameModal,
      // toggle all off only (property name kept for consistency)
      toggle: () => {
        setShowCopyModal(false);
        setShowCreateModal(false);
        setShowDeleteModal(false);
        setShowMoveModal(false);
        setShowRenameModal(false);
        setShowImportModal(false);
      },
    },
    [TemplateFolderModals.Copy]: {
      isShown: showCopyModal,
      toggle: (newState?: boolean) => {
        setShowCopyModal(newState ?? !showCopyModal);
      },
    },
    [TemplateFolderModals.Create]: {
      isShown: showCreateModal,
      toggle: (newState?: boolean) => {
        setShowCreateModal(newState ?? !showCreateModal);
      },
    },
    [TemplateFolderModals.Delete]: {
      isShown: showDeleteModal,
      toggle: (newState?: boolean) => {
        setShowDeleteModal(newState ?? !showDeleteModal);
      },
    },
    [TemplateFolderModals.Move]: {
      isShown: showMoveModal,
      toggle: (newState?: boolean) => {
        setShowMoveModal(newState ?? !showMoveModal);
      },
    },
    [TemplateFolderModals.Rename]: {
      isShown: showRenameModal,
      toggle: (newState?: boolean) => {
        setShowRenameModal(newState ?? !showRenameModal);
      },
    },
    [TemplateFolderModals.Import]: {
      isShown: showImportModal,
      toggle: (newState?: boolean) => {
        setShowImportModal(newState ?? !showImportModal);
      },
    },
  };
}
